import {IntermediatePart} from "../../intermediatePart";
import Cabinet from "../../parts/cabinet";
import {LayoutAbbreviations} from "../../constants";

export default class Backsplash extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'backsplash';
    this.partName = 'Backsplash';
    this.translateId = "visualizer.kitchen.walls.backsplash";
    this.isStoneFeature = true;
    this.allWallsCanBeApplied = true;
    if (isChild) {
      this.nextFeaturesPageToLoadArray = {};
      LayoutAbbreviations.forEach(layoutAbbreviation => {
        this.nextFeaturesPageToLoadArray[layoutAbbreviation] = {
          page: 0,
          allReceived: false,
        };
      });
    }
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Backsplash());
  }

  getNavItemsWithSameName(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    let featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(true), filteredAvailableFeatures);
    if (this.activeFeature) {
      let activeType = this.getFeatureBacksplashType(this.activeFeature);
      featuresToDisplay = featuresToDisplay.filter(feature => this.getFeatureBacksplashType(feature) === activeType);

      if (this.featureIsFullWall(this.activeFeature)) { // full backsplashes should be filtered by CabinetLayout metaData
        const cabinetParent = this.getParent().layout.parts[Cabinet.id];
        const cabinetLayoutMetaData = cabinetParent && cabinetParent.topCabinet && cabinetParent.topCabinet.activeFeature
          && cabinetParent.topCabinet.activeFeature.metaData && cabinetParent.topCabinet.activeFeature.metaData["CabinetLayout"];
        if (cabinetLayoutMetaData) {
          featuresToDisplay = featuresToDisplay.filter(feature => feature.metaData && feature.metaData["CabinetLayout"]
            && feature.metaData["CabinetLayout"].includes(cabinetLayoutMetaData[0]))
        }
      }
    }
    return featuresToDisplay
  }

  navigationSubItems(filters, searchText) {
    const featuresToDisplay = this.getNavItemsWithSameName(filters, searchText);
    return this.returnUniqueNavFeatures(this.getUniqueFeatures(featuresToDisplay));
  }

  getUniqueFeatures(featuresToDisplay) { // remove bathroom backsplashes (with the same name and not in visualizer)
    return featuresToDisplay.filter(feature => {
      const featureSplittedName = feature.getSplittedFeatureName();
      return !(feature.notAvailableInVisualizer && featuresToDisplay.some(countertop => {
        return countertop.getSplittedFeatureName() === featureSplittedName
      }));
    })
  }

  getFeatureByBacksplashType(neededType, featureName = "") {
    const conditions = this.getArrayOfConditions();
    let featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(conditions);
    const matchingFeatures = featuresToDisplay.filter(feature => this.getFeatureBacksplashType(feature) === neededType);

    let currentPartName = featureName;
    if (!currentPartName && this.activeFeature) {
      currentPartName = this.activeFeature.getCountertopGroupsSplittedFeatureName();
    }

    const matchByName = matchingFeatures.filter(feature => {
      return feature.getCountertopGroupsSplittedFeatureName() === currentPartName
    });
    if (matchByName.length > 1) {
      const cabinetLayoutMetaData = this.getTopCabinetCabinetLayoutMetadata();
      const sameCabinetType = matchByName.find(feature => {
        if (this.featureIsFullWall(feature)) {
          return feature.matchesMetaForArrayOfConditions([
            {
              propName: 'CabinetLayout',
              propValue: cabinetLayoutMetaData
            }
          ])
        }
      });
      return sameCabinetType || matchByName[0];
    }
    return matchByName[0] || matchingFeatures[0];
  }

  featureIsFullWall = (feature) => {
    return this.getFeatureBacksplashType(feature) === "Full"
  }

  getFeatureBacksplashType = (feature) => {
    return feature && Array.isArray(feature.metaData["BacksplashType"]) ? feature.metaData["BacksplashType"][0] : null
  }

  getCurrentActiveFeatureType() {
    return this.getFeatureBacksplashType(this.activeFeature)
  }

  // setFeatureByName = async () => {
  //   window.requestInProcess = true;
  //   loaderEnable();
  //   const splittedName = this.activeFeature.getCountertopGroupsSplittedFeatureName();
  //   await Navigation.searchFeaturesByName(this, splittedName);
  //   const neededFeature = this.findFeatureByPartName(splittedName, true);
  //   if (neededFeature) {
  //     this.activeFeature = neededFeature;
  //   }
  //   window.requestInProcess = false;
  //   loaderDisable();
  //   $(window).trigger(ActionTypes.CHANGE_LAYOUT); // update canvas
  // };

  getTopCabinetCabinetLayoutMetadata() {
    const cabinetParent = this.getParent().layout.parts[Cabinet.id];
    return cabinetParent && cabinetParent.topCabinet && cabinetParent.topCabinet.activeFeature
      && cabinetParent.topCabinet.activeFeature.metaData && cabinetParent.topCabinet.activeFeature.metaData["CabinetLayout"];
  }
}
